import { render, staticRenderFns } from "./DynamicInfo.vue?vue&type=template&id=f2e6bad2&scoped=true"
import script from "./DynamicInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DynamicInfo.vue?vue&type=style&index=0&id=f2e6bad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e6bad2",
  null
  
)

export default component.exports